module.exports = __webpack_public_path__ + "static/img/crude-2.29ed2b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zh_crude/crude-2.png
// module id = 246
// module chunks = 6